import { React, PT } from '@gasbuddy/react';
import { Table, Menu, Icon } from 'semantic-ui-react';

export const IdTable = ({
  accounts, onSelected, showPrevious, pageSize, onNext, onPrev, range,
}) => {
  if (!accounts) {
    return null;
  }
  return (
    <Table selectable>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell width={2}>Account Id</Table.HeaderCell>
          <Table.HeaderCell width={2}>Type</Table.HeaderCell>
          <Table.HeaderCell>Identifier</Table.HeaderCell>
        </Table.Row>
      </Table.Header>

      <Table.Body>
        {accounts.slice(0, pageSize).map(a => (
          <Table.Row
            key={a.account_id}
            onClick={() => onSelected(a.account_id)}
            disabled={!!(a.released_at || a.deleted_at)}
          >
            <Table.Cell>{a.account_id}</Table.Cell>
            <Table.Cell>{a.type}</Table.Cell>
            <Table.Cell>{a.identifier}</Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>

      {onNext && accounts.length > 0
        && (
        <Table.Footer>
          <Table.Row>
            <Table.Cell colSpan={2}>
              {range}
            </Table.Cell>
            <Table.Cell textAlign="right">
              <Menu pagination>
                {showPrevious && (
                <Menu.Item as="a" icon onClick={onPrev}>
                  <Icon name="left chevron" />
                </Menu.Item>
                )}
                {accounts && accounts.length > pageSize && (
                <Menu.Item as="a" icon onClick={onNext}>
                  <Icon name="right chevron" />
                </Menu.Item>
                )}
              </Menu>
            </Table.Cell>
          </Table.Row>
        </Table.Footer>
        )
      }
    </Table>
  );
};

IdTable.propTypes = {
  accounts: PT.arrayOf(PT.shape({
    account_id: PT.number.isRequired,
    type: PT.string.isRequired,
    identifier: PT.string.isRequired,
  })),
  onSelected: PT.func.isRequired,
  onNext: PT.func.isRequired,
  onPrev: PT.func.isRequired,
  range: PT.string.isRequired,
  pageSize: PT.number,
  showPrevious: PT.boolean,
};

IdTable.defaultProps = {
  accounts: [],
  pageSize: 0,
  showPrevious: false,
};
